import React from "react";
import Table from "../../../components/table/table";
import Icon from "../../../components/icon/icon";
import { FAQ } from "../../../types";
import { FaqTableProps } from "../types/faq-types";
import { ITEMS_PER_PAGE_OPTIONS } from "../../../constants/pagination";
import { getFaqQuestion, getFaqAnswerPreview } from "../utils/faq-utils";

export const FaqTable: React.FC<FaqTableProps> = ({
  faqs,
  isLoading,
  currentPage,
  itemsPerPage,
  totalPages,
  onEdit,
  onDelete,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const columns = [
    {
      title: "Вопрос",
      dataIndex: "question" as keyof FAQ,
      key: "question",
      render: (question: string, record: FAQ) => (
        <div className="faq__question-cell">
          <div className="faq__question-text">{getFaqQuestion(record)}</div>
        </div>
      ),
    },
    {
      title: "Ответ",
      dataIndex: "answer" as keyof FAQ,
      key: "answer",
      render: (answer: string, record: FAQ) => (
        <div className="faq__answer-cell">
          <div className="faq__answer-text">
            {getFaqAnswerPreview(record, 100)}
          </div>
        </div>
      ),
    },
    {
      title: "Действия",
      key: "actions",
      dataIndex: "id" as keyof FAQ,
      render: (_: any, record: FAQ) => (
        <div className="faq__actions">
          <button
            onClick={() => onEdit(record)}
            className="faq__action-btn"
            title="Редактировать"
          >
            <Icon name="pencil" size="small" />
          </button>
          <button
            onClick={() => onDelete(record)}
            className="faq__action-btn faq__action-btn--delete"
            title="Удалить"
          >
            <Icon name="delete" size="small" />
          </button>
        </div>
      ),
    },
  ];

  const handleItemsPerPageChange = (value: string): void => {
    onItemsPerPageChange(parseInt(value));
  };

  return (
    <div className="faq__table-container">
      <Table
        columns={columns}
        dataSource={faqs}
        rowKey="id"
        loading={isLoading}
        emptyMessage="FAQ не найдены"
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
      />

      <div className="faq__pagination">
        <div className="faq__pagination-info">
          Показано {Math.min((currentPage - 1) * itemsPerPage + 1, faqs.length)}{" "}
          - {Math.min(currentPage * itemsPerPage, faqs.length)} из {faqs.length}
        </div>

        <div className="faq__pagination-controls">
          <select
            value={itemsPerPage}
            onChange={(e) => handleItemsPerPageChange(e.target.value)}
            className="faq__page-size-select"
          >
            {ITEMS_PER_PAGE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option} на странице
              </option>
            ))}
          </select>

          <div className="faq__page-buttons">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="faq__page-btn"
            >
              <Icon name="left" size="small" />
            </button>

            <span className="faq__page-info">
              {currentPage} из {totalPages}
            </span>

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="faq__page-btn"
            >
              <Icon name="right" size="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
